import parse from 'html-react-parser'
class ActionProvider {
    constructor(createChatBotMessage, setStateFunc) {
      this.createChatBotMessage = createChatBotMessage;
      this.setState = setStateFunc;
    }
    
    greet() {
        // const greetingMessage = this.createChatBotMessage('Hi, friend.');
        // this.updateChatbotState(greetingMessage);

        const greetingMessage = this.createChatBotMessage('Hi there! You can use this tool to help you find answers to your questions about Interac products and services. Please select one of the options below.');
        this.updateChatbotState(greetingMessage);
    }

    careers() {
      const careersMessage = this.createChatBotMessage(parse('Power your future with a career at Interac. <a href="https://www.interac.ca/en/about/careers/">Learn</a> about open positions.'));
      this.updateChatbotState(careersMessage);

      const moreQuestionsMessage = this.createChatBotMessage(parse('Is there anything else I can help with?'),
        {
          widget: 'MoreQuestions',
        }
      );
      this.updateChatbotState(moreQuestionsMessage);
    }

    contactUs() {
      const contactUs = this.createChatBotMessage(parse('Visit our <a href="https://www.interac.ca/en/contact-us/">contact us</a> page for details.'));
      this.updateChatbotState(contactUs);

      const moreQuestionsMessage = this.createChatBotMessage(parse('Is there anything else I can help with?'),
        {
          widget: 'MoreQuestions',
        }
      );
      this.updateChatbotState(moreQuestionsMessage);
    }


    WhatIseTransfer() {
      const WhatIseTransferMessage = this.createChatBotMessage(parse('<em>Interac</em> e-Transfer is a fast, secure and convenient way to send money to anyone in Canada using online banking. The participating bank or credit union transfers the funds using established and secure banking procedures. Transfers are almost instant, but can take up to 30 minutes depending on your bank or credit union.'));
      this.updateChatbotState(WhatIseTransferMessage);

      const moreQuestionsMessage = this.createChatBotMessage(parse('Is there anything else I can help with?'),
        {
          widget: 'MoreQuestions',
        }
      );
      this.updateChatbotState(moreQuestionsMessage);
    }

  eTransferContact() {
    const eTransferContactMessage = this.createChatBotMessage(parse('Please contact your bank or credit union to troubleshoot any transactions in progress. The contact information is usually on the back of your <em>Interac</em> debit card. You can also use this <em>Interac</em> e-Transfer form.'));
    this.updateChatbotState(eTransferContactMessage);

    const moreQuestionsMessage = this.createChatBotMessage(parse('Is there anything else I can help with?'),
        {
          widget: 'MoreQuestions',
        }
      );
      this.updateChatbotState(moreQuestionsMessage);
  }

  eTransferHowToSend() {
    const eTransferHowToSend = this.createChatBotMessage(parse('Exact steps vary by individual bank or credit union, but the process will always be simple. Just log into your online bank account, navigate to the <em>Interac</em> e-Transfer section and follow the instructions.'));
    this.updateChatbotState(eTransferHowToSend);

    const moreQuestionsMessage = this.createChatBotMessage(parse('Is there anything else I can help with?'),
        {
          widget: 'MoreQuestions',
        }
      );
      this.updateChatbotState(moreQuestionsMessage);
  }

  eTransferHowToCancel() {
    const eTransferHowToCancel = this.createChatBotMessage(parse('To cancel a transfer, log into your online bank account. Go to the transaction or payment history and select the <em>Interac</em> e-Transfer transaction you wish to cancel. Use the cancel option provided. This process varies by financial institution, who may also charge a cancellation fee. Contact your bank or credit union for more information.'));
    this.updateChatbotState(eTransferHowToCancel);

    const moreQuestionsMessage = this.createChatBotMessage(parse('Is there anything else I can help with?'),
        {
          widget: 'MoreQuestions',
        }
      );
      this.updateChatbotState(moreQuestionsMessage);
  }

  HowToDeposit() {
    const HowToDepositMessage = this.createChatBotMessage(parse('When someone sends you money via <em>Interac</em> e-Transfer, you will receive an email or text message that a transfer has been sent to you. The notification includes information such as Sender\'s name, Transfer amount A link to deposit your transfer to your bank account. The fastest way to get your funds is through your financial institution’s online or mobile banking service. Simply click the link in the notification, select your bank or credit union, login to online or mobile banking and deposit the money into the account of your choice. If you cannot click on the link, either cut and paste or type the link into your browser. You will be prompted to enter the answer to a security question set by the sender, as part of the secure login process. Alternatively, Autodeposit is an <em>Interac</em> e-Transfer feature that allows users to register to have incoming <em>Interac</em> e–Transfer funds deposited directly into their bank account – no security question and answer needed. Learn more about <em>Interac</em> e-Transfer enhanced features below.'));
    this.updateChatbotState(HowToDepositMessage);

    const moreQuestionsMessage = this.createChatBotMessage(parse('Is there anything else I can help with?'),
        {
          widget: 'MoreQuestions',
        }
      );
      this.updateChatbotState(moreQuestionsMessage);
  }

  HowToSecureEtransfer() {
    const HowToSecureEtransferMessage = this.createChatBotMessage('You are not sending money by email or text message: Only the notification travels over the Internet to advise the recipient that the transfer has been initiated and to provide instructions on how to deposit the money. The money always resides safely at a financial institution and is transferred through existing payment networks that banks and credit unions have used for years to settle cheques, bank machine deposits and withdrawals. Security measures have been built into the system, including: Encryption technology, Confidential user IDs and passwords issued by financial institutions, Secure login process, A security question and answer to ensure only the intended recipient receives the money, 128-bit browser encryption.');
    this.updateChatbotState(HowToSecureEtransferMessage);

    const moreQuestionsMessage = this.createChatBotMessage(parse('Is there anything else I can help with?'),
        {
          widget: 'MoreQuestions',
        }
      );
      this.updateChatbotState(moreQuestionsMessage);
  }

  etransferCost() {
    const etransferCostMessage = this.createChatBotMessage(parse('There may be a fee from your financial institution for using the <em>Interac</em> e-Transfer service. Please check with your bank or credit union directly.'));
    this.updateChatbotState(etransferCostMessage);

    const moreQuestionsMessage = this.createChatBotMessage(parse('Is there anything else I can help with?'),
        {
          widget: 'MoreQuestions',
        }
      );
      this.updateChatbotState(moreQuestionsMessage);
  }

  etransferLimit() {
    const etransferLimitMessage = this.createChatBotMessage('Like most financial transactions, there are limits on the amount you can send. Each financial institution sets their own. Please contact your bank or credit union for details.');
    this.updateChatbotState(etransferLimitMessage);

    const moreQuestionsMessage = this.createChatBotMessage(parse('Is there anything else I can help with?'),
        {
          widget: 'MoreQuestions',
        }
      );
      this.updateChatbotState(moreQuestionsMessage);
  }

  etransferStopTxt() {
    const etransferStopTxtMessage = this.createChatBotMessage(parse('You received a text notification because the sender selected “text message” to send you money via <em>Interac</em> e-Transfer. We recommend you provide the sender with your email address instead for sending. To permanently stop all text notifications from <em>Interac</em> e-Transfer, reply to an <em>Interac</em> e-Transfer text with the message STOP (or text STOP to 100001). Please note: Once stopped, text message notifications cannot be reinstated for all transactions moving forward. Standard text messaging rates apply.'));
    this.updateChatbotState(etransferStopTxtMessage);

    const moreQuestionsMessage = this.createChatBotMessage(parse('Is there anything else I can help with?'),
        {
          widget: 'MoreQuestions',
        }
      );
      this.updateChatbotState(moreQuestionsMessage);
  }
  etransferNonCanadian() {
    const etransferNonCanadianMessage = this.createChatBotMessage('If you have received an <em>Interac</em> e-Transfer and do not have an account with a participating Canadian bank, ask your sender to cancel the transfer. Once the transfer is cancelled, the funds will be returned to the sender’s account. If you are unable to contact your sender, the transfer will expire in approximately 30 days. Once the transfer expires, the money is automatically deposited into the sender’s account.');
    this.updateChatbotState(etransferNonCanadianMessage);

    const moreQuestionsMessage = this.createChatBotMessage(parse('Is there anything else I can help with?'),
        {
          widget: 'MoreQuestions',
        }
      );
      this.updateChatbotState(moreQuestionsMessage);
  }

  etransferNoBank() {
    const etransferNoBankMessage = this.createChatBotMessage(parse('If your bank or credit union doesn’t offer <em>Interac</em> e-Transfer, you cannot receive funds. Please contact your bank or financial institution for additional information.'));
    this.updateChatbotState(etransferNoBankMessage);

    const moreQuestionsMessage = this.createChatBotMessage(parse('Is there anything else I can help with?'),
        {
          widget: 'MoreQuestions',
        }
      );
      this.updateChatbotState(moreQuestionsMessage);
  }
  etransferSecurityQA() {
    const etransferSecurityQAMessage = this.createChatBotMessage(parse('If you don’t know the answer to the security question, contact the sender. If you answer the security question incorrectly more than three times, the <em>Interac</em> e-Transfer transaction will automatically cancel.'));
    this.updateChatbotState(etransferSecurityQAMessage);

    const moreQuestionsMessage = this.createChatBotMessage(parse('Is there anything else I can help with?'),
        {
          widget: 'MoreQuestions',
        }
      );
      this.updateChatbotState(moreQuestionsMessage);
  }
  whatisAutodeposit() {
    const whatisAutodeposit = this.createChatBotMessage(parse('Autodeposit is an <em>Interac</em> e-Transfer feature that allows users to register to have incoming <em>Interac</em> e–Transfer funds deposited directly into their bank account – no security question and answer needed. <a href="https://www.interac.ca/en/consumers/products/interac-e-transfer/enhanced-features/#fi-list-autodeposit" target="_blank">Click here</a> for a list of participating banks and credit unions, and to learn more about the <em>Interac</em> e-Transfer Autodeposit feature.'));
    this.updateChatbotState(whatisAutodeposit);

    const moreQuestionsMessage = this.createChatBotMessage(parse('Is there anything else I can help with?'),
        {
          widget: 'MoreQuestions',
        }
      );
      this.updateChatbotState(moreQuestionsMessage);
  }
  DebitWorks() {
    const DebitWorksMessage = this.createChatBotMessage(parse('<em>Interac</em> Debit and <em>Interac</em> Contactless transactions are approved by your bank or credit union through secure online systems in real-time. Transactions appear instantly on your bank account records, allowing you to monitor your available balance so you can keep track of your spending.'));
    this.updateChatbotState(DebitWorksMessage);

    const moreQuestionsMessage = this.createChatBotMessage(parse('Is there anything else I can help with?'),
        {
          widget: 'MoreQuestions',
        }
      );
      this.updateChatbotState(moreQuestionsMessage);
  }

  DebitSecurity() {
    const DebitSecurityMessage = this.createChatBotMessage(parse('<em>Interac</em> Debit and <em>Interac</em> Flash are extremely secure forms of payment with sophisticated safeguards and fraud detection tools in place to protect you: <em>Interac</em> debit cards use EMV secure chip processing to store and process data securely. This makes it next to impossible to create counterfeit cards and protects you against fraud tactics such as skimming, transaction replay and electronic pickpocketing. When you use <em>Interac</em> Debit on your mobile device, you enjoy the same security features as your <em>Interac</em> debit card, as well as your device’s standard security measures such as passcode or biometric ID verification. Transaction limits are set at $100 per transaction.  There is also added protection of a cumulative contactless limit set by individual banks or credit unions.  A cumulative limit is the maximum contactless spend limit that can be done by an individual <em>Interac</em> debit card before the user is promoted to reset the limit with a Chip and PIN transaction. This confirms that you are the authorized cardholder. You are also protected from any losses due to unauthorized transactions under the <em>Interac</em> Zero Liability Policy. If your card is lost or stolen, contact your bank or credit union right away.'));
    this.updateChatbotState(DebitSecurityMessage);

    const moreQuestionsMessage = this.createChatBotMessage(parse('Is there anything else I can help with?'),
        {
          widget: 'MoreQuestions',
        }
      );
      this.updateChatbotState(moreQuestionsMessage);
  }
  ApplePayDebit() {
    const ApplePayDebitMessage = this.createChatBotMessage(parse('<em>Interac</em> Debit on Apple Pay is a new way to make debit payments using <em>Interac</em> Debit on your eligible Apple device.<em>Interac</em> Debit for In-App & In-Browser payments is the easy, fast, and secure way for Canadians to pay directly from their bank account when shopping online using their mobile device. An in-app payment takes place within the merchant’s native mobile app. An in-browser payment takes place within a supported mobile browser (i.e Safari).'));
    this.updateChatbotState(ApplePayDebitMessage);

    const moreQuestionsMessage = this.createChatBotMessage(parse('Is there anything else I can help with?'),
        {
          widget: 'MoreQuestions',
        }
      );
      this.updateChatbotState(moreQuestionsMessage);
  }
  ApplePay() {
    const ApplePayMessage = this.createChatBotMessage(parse('<em>Interac</em> Debit cardholders with a debit card issued from participating financial institutions can use <em>Interac</em> Debit to pay with Apple Pay at merchants who accept <em>Interac</em> Flash contactless payments. For in-app and in-browser transactions, <em>Interac</em> debit cardholders with a debit card issued from participating financial institutions can pay on select merchant applications or mobile websites using Apple Pay. We are continuously working to onboard more issuers and merchants to support in-app and in-browser with <em>Interac</em> Debit.'));
    this.updateChatbotState(ApplePayMessage);

    const moreQuestionsMessage = this.createChatBotMessage(parse('Is there anything else I can help with?'),
        {
          widget: 'MoreQuestions',
        }
      );
      this.updateChatbotState(moreQuestionsMessage);
  }
  requestMoney() {
    const requestMoneyMessage = this.createChatBotMessage(parse('Request Money is a feature that allows you to send a request for funds via the <em>Interac</em> e-Transfer system. To learn more about <em>Interac</em> e-Transfer, click here. Once the request is fulfilled and the funds are available in your account, you will receive a notification via text or email.'));
    this.updateChatbotState(requestMoneyMessage);

    const moreQuestionsMessage = this.createChatBotMessage(parse('Is there anything else I can help with?'),
        {
          widget: 'MoreQuestions',
        }
      );
      this.updateChatbotState(moreQuestionsMessage);
  }
  whatisOpenPayment() {
    const whatisOpenPayment = this.createChatBotMessage(parse('Transit Open Payments or open payment fare systems provide the ability for transit riders to tap a payment card or a mobile wallet at fare readers without the need to use a transit fare card or transit app to pay for their fare. Interac is enabling the ability for a debit card or mobile wallet supported by <em>Interac</em><sup>&reg;</sup> Debit to be used for this purpose.'));
    this.updateChatbotState(whatisOpenPayment);

    const moreQuestionsMessage = this.createChatBotMessage(parse('Is there anything else I can help with?'),
        {
          widget: 'MoreQuestions',
        }
      );
      this.updateChatbotState(moreQuestionsMessage);
  }
  whereCanIUseDebitonTransit() {
    const whereCanIUseDebitonTransit = this.createChatBotMessage(parse('The ability to pay for transit directly via Interac Debit is available by Metrolinx on the UP Express in Toronto and TransLink in Vancouver.Additional transit authorities across the GTHA have recently been added including GO Transit, Brampton Transit, Burlington Transit, Durham Region Transit, Hamilton Street Railway, MiWay in Mississauga, Oakville Transit, York Region Transit, Para Transpo in Ottawa and more to come.'));
    this.updateChatbotState(whereCanIUseDebitonTransit);

    const moreQuestionsMessage = this.createChatBotMessage(parse('Is there anything else I can help with?'),
        {
          widget: 'MoreQuestions',
        }
      );
      this.updateChatbotState(moreQuestionsMessage);
  }
  tryAgain() {
    const tryAgainMessage = this.createChatBotMessage(parse('Sorry I\'m still learning and didn\'t understand your question. Try using different key words, or <a href="https://www.interac.ca/en/contact-us/" target="_blank">Contact Us</a> for further assistance.'));
    this.updateChatbotState(tryAgainMessage);
  }


  moreQuestions () {
    const moreQuestionsMessage = this.createChatBotMessage(parse('Is there anything else I can help with?'),
      {
        widget: 'learningOptions',
      }
    );
    this.updateChatbotState(moreQuestionsMessage);
  }

  handleGreet = () => {
    const message = this.createChatBotMessage(
      'Hi there! You can use this tool to help you find answers to your questions about Interac products and services. Please select one of the options below.',
      {
        widget: 'learningOptions',
      }
    );

    this.updateChatbotState(message);
  };

    handleConsumerProducts = () => {
      const message = this.createChatBotMessage(
        'Which product can we help you with?',
        {
          widget: 'ConsumerProducts',
        }
      );
  
      this.updateChatbotState(message);
    };

    handleEtransfer = () => {
      const user_message = this.createChatBotMessage(
        parse('<em>Interac</em> e-Transfer'),
      );
      const message = this.createChatBotMessage(
        'Which product can we help you with?',
        {
          widget: 'EtransferOptions',
        }
      );
      this.updateChatbotState(user_message);
      this.updateChatbotState(message);
    };

    handleAutodeposit = () => {
      // window.open('https://www.interac.ca/en/consumers/products/interac-e-transfer/', '_blank');
      const user_message = this.createChatBotMessage(
        'Autodesposit',
      );
      const message = this.createChatBotMessage(
        'What kind of question do you have?',
        {
          widget: 'AutodespositOptions',
        }
      );
      this.updateChatbotState(user_message);
      this.updateChatbotState(message);
    };
    handleEtransfer1 = () => {
      const handleEtransfer1 = this.createChatBotMessage(parse('Please contact your bank or credit union to troubleshoot any transactions in progress. The contact information is usually on the back of your Interac debit card. You can also use this <a href="https://www.interac.ca/en/consumers/support/interac-e-transfer-customer-support-form/"><em>Interac</em> e-Transfer form</a>.'));
      this.updateChatbotState(handleEtransfer1);

      const moreQuestionsMessage = this.createChatBotMessage(parse('Is there anything else I can help with?'),
        {
          widget: 'MoreQuestions',
        }
      );
      this.updateChatbotState(moreQuestionsMessage);
    };
    handleEtransfer2 = () => {
      const handleEtransfer2 = this.createChatBotMessage(parse('No. While all three methods allow you to directly pay with funds from your own bank account, <em>Interac</em> e-Transfer electronically transfers money from your bank account to another one. <em>Interac</em> Debit and <em>Interac</em> Debit for online payments uses a different method of payment.'));
      this.updateChatbotState(handleEtransfer2);

      const moreQuestionsMessage = this.createChatBotMessage(parse('Is there anything else I can help with?'),
        {
          widget: 'MoreQuestions',
        }
      );
      this.updateChatbotState(moreQuestionsMessage);
    };
    handleEtransfer3 = () => {
      const handleEtransfer3 = this.createChatBotMessage(parse('Exact steps vary by individual bank or credit union, but the process will always be simple. Just log into your online bank account, navigate to the <em>Interac</em> e-Transfer section and follow the instructions.'));
      this.updateChatbotState(handleEtransfer3);

      const moreQuestionsMessage = this.createChatBotMessage(parse('Is there anything else I can help with?'),
        {
          widget: 'MoreQuestions',
        }
      );
      this.updateChatbotState(moreQuestionsMessage);
    };
    handleEtransfer4 = () => {
      const handleEtransfer4 = this.createChatBotMessage(parse('To cancel a transfer, log into your online bank account. Go to the transaction or payment history and select the <em>Interac</em> e-Transfer transaction you wish to cancel. Use the cancel option provided. This process varies by financial institution, who may also charge a cancellation fee. Contact your bank or credit union for more information.'));
      this.updateChatbotState(handleEtransfer4);

      const moreQuestionsMessage = this.createChatBotMessage(parse('Is there anything else I can help with?'),
        {
          widget: 'MoreQuestions',
        }
      );
      this.updateChatbotState(moreQuestionsMessage);
    };
    handleEtransfer5 = () => {
      const handleEtransfer5 = this.createChatBotMessage(parse('Unfortunately, once a deposit has been made there is no way to reverse the transaction. You’ll have to make arrangements directly with the recipient. You should only send money transfers to parties you know and trust. For most Interac e-Transfer uses (sending money to family and friends, repaying IOUs, sending money as gifts, etc.), you will know the recipient well. For uses where you may not know the recipient (e.g., online auction purchases), take the same precautions you would take when making cash purchases. For online auctions and purchases, be sure to read and follow any steps recommended by the operators of these websites to safely transact.'));
      this.updateChatbotState(handleEtransfer5);

      const moreQuestionsMessage = this.createChatBotMessage(parse('Is there anything else I can help with?'),
        {
          widget: 'MoreQuestions',
        }
      );
      this.updateChatbotState(moreQuestionsMessage);
    };
    handleEtransfer6 = () => {
      const handleEtransfer6 = this.createChatBotMessage(parse('When someone sends you money via Interac e-Transfer, you will receive an email or text message that a transfer has been sent to you. The notification includes information such as: <ul><li>Sender’s name</li><li>Transfer amount</li><li>A link to deposit your transfer to your bank account</li></ul><br />The fastest way to get your funds is through your financial institution’s online or mobile banking service. Simply click the link in the notification, select your bank or credit union, login to online or mobile banking and deposit the money into the account of your choice. If you cannot click on the link, either cut and paste or type the link into your browser. You will be prompted to enter the answer to a security question set by the sender, as part of the secure login process. Alternatively, Autodeposit is an Interac e-Transfer feature that allows users to register to have incoming Interac e–Transfer funds deposited directly into their bank account – no security question and answer needed. Learn more about Interac e-Transfer enhanced features below.'));
      this.updateChatbotState(handleEtransfer6);

      const moreQuestionsMessage = this.createChatBotMessage(parse('Is there anything else I can help with?'),
        {
          widget: 'MoreQuestions',
        }
      );
      this.updateChatbotState(moreQuestionsMessage);
    };
    handleEtransfer7 = () => {
      const handleEtransfer7 = this.createChatBotMessage(parse('You are not sending money by email or text message: Only the notification travels over the Internet to advise the recipient that the transfer has been initiated and to provide instructions on how to deposit the money. The money always resides safely at a financial institution and is transferred through existing payment networks that banks and credit unions have used for years to settle cheques, bank machine deposits and withdrawals. Security measures have been built into the system, including:<ul><li>Encryption technology</li><li>Confidential user IDs and passwords issued by financial institutions</li><li>Secure login process</li><li>A security question and answer to ensure only the intended recipient receives the money</li><li>128-bit browser encryption</li>'));
      this.updateChatbotState(handleEtransfer7);

      const moreQuestionsMessage = this.createChatBotMessage(parse('Is there anything else I can help with?'),
        {
          widget: 'MoreQuestions',
        }
      );
      this.updateChatbotState(moreQuestionsMessage);
    };

    handleAutodeposit1 = () => {
      const handleAutodeposit1 = this.createChatBotMessage(parse('Autodeposit is an <em>Interac</em> e-Transfer feature that allows users to register to have incoming <em>Interac</em> e–Transfer funds deposited directly into their bank account – no security question and answer needed. <a href="https://www.interac.ca/en/consumers/products/interac-e-transfer/enhanced-features/#fi-list-autodeposit" target="_blank">Click here</a> for a list of participating banks and credit unions, and to learn more about the <em>Interac</em> e-Transfer Autodeposit feature.'));
      this.updateChatbotState(handleAutodeposit1);

      const moreQuestionsMessage = this.createChatBotMessage(parse('Is there anything else I can help with?'),
        {
          widget: 'MoreQuestions',
        }
      );
      this.updateChatbotState(moreQuestionsMessage);
    };

    handleAutodeposit2 = () => {
      const handleAutodeposit2 = this.createChatBotMessage(parse('Yes. Autodeposit enjoys the same bank-grade security standard as <em>Interac</em> e-Transfer. <em>Interac</em> e-Transfer is one of the safest digital money transfer services in the world. When you send or request money via <em>Interac</em> e-Transfer, the funds are transferred through established and secure banking procedures that banks and credit unions have used for years. Money never travels by email or text – these are simply used to notify you about the transaction, as well as provide deposit instructions.'));
      this.updateChatbotState(handleAutodeposit2);

      const moreQuestionsMessage = this.createChatBotMessage(parse('Is there anything else I can help with?'),
        {
          widget: 'MoreQuestions',
        }
      );
      this.updateChatbotState(moreQuestionsMessage);
    };
    handleAutodeposit3 = () => {
      const handleAutodeposit3 = this.createChatBotMessage(parse('The availability of the Autodeposit feature, along with the experience to register, will vary by financial institution. To register for <em>Interac</em> e-Transfer Autodeposit, log into your online or mobile banking account and go to your <em>Interac</em> e-Transfer profile settings. Once there, add the identifier (email address or text) you want associated with <em>Interac</em> e-Transfer Autodeposit and select the account into which you want funds deposited. You will receive a request to verify registration. The next time someone sends funds to the identifier registered, the money will be deposited directly into your account without the need to answer a security question.'));
      this.updateChatbotState(handleAutodeposit3);

      const moreQuestionsMessage = this.createChatBotMessage(parse('Is there anything else I can help with?'),
        {
          widget: 'MoreQuestions',
        }
      );
      this.updateChatbotState(moreQuestionsMessage);
    };
    handleAutodeposit4 = () => {
      const handleAutodeposit4 = this.createChatBotMessage(parse('Some financial institutions might not offer <em>Interac</em> e-Transfer Autodeposit. Check with your participating bank or credit union to confirm.'));
      this.updateChatbotState(handleAutodeposit4);

      const moreQuestionsMessage = this.createChatBotMessage(parse('Is there anything else I can help with?'),
        {
          widget: 'MoreQuestions',
        }
      );
      this.updateChatbotState(moreQuestionsMessage);
    };
    handleAutodeposit5 = () => {
      const handleAutodeposit5 = this.createChatBotMessage('If you haven’t received the Autodeposit verification email, check your junk email folder. If you still can’t find the notification, you’ll have to re-register for the feature through your bank or credit union’s online banking or mobile banking application.');
      this.updateChatbotState(handleAutodeposit5);

      const moreQuestionsMessage = this.createChatBotMessage(parse('Is there anything else I can help with?'),
        {
          widget: 'MoreQuestions',
        }
      );
      this.updateChatbotState(moreQuestionsMessage);
    };
    
    handleRequestMoney = () => {
      //window.open('https://www.interac.ca/en/consumers/products/interac-e-transfer/enhanced-features/#interac-etransfer-request-money', '_blank');
      const message = this.createChatBotMessage(
        'What kind of question do you have?',
        {
          widget: 'RequestMoneyOptions',
        }
      );
  
      this.updateChatbotState(message);
    };

    handleRequestMoney1 = () => {
      const handleRequestMoney1 = this.createChatBotMessage(parse('Request Money is a feature that allows you to send a request for funds via the <em>Interac</em> e-Transfer system. To learn more about <em>Interac</em> e-Transfer, click here. Once the request is fulfilled and the funds are available in your account, you will receive a notification via text or email. Click here for a list of participating banks and credit unions, and to learn more about the <em>Interac</em> e-Transfer Request Money feature.'));
      this.updateChatbotState(handleRequestMoney1);

      const moreQuestionsMessage = this.createChatBotMessage(parse('Is there anything else I can help with?'),
        {
          widget: 'MoreQuestions',
        }
      );
      this.updateChatbotState(moreQuestionsMessage);
    };

    handleRequestMoney2 = () => {
      const handleRequestMoney2 = this.createChatBotMessage(parse('Yes, you can opt-out of receiving requests from a particular requestor or of the service completely, by selecting the opt-out option on the fulfillment page. You can also opt-in to receive requests from a particular individual, or for the service, by managing your preference through your financial institution’s online banking or mobile banking application. Simply navigate to the <em>Interac</em> e-Transfer settings or by clicking here. Please note this experience will vary by participating financial institution.'));
      this.updateChatbotState(handleRequestMoney2);

      const moreQuestionsMessage = this.createChatBotMessage(parse('Is there anything else I can help with?'),
        {
          widget: 'MoreQuestions',
        }
      );
      this.updateChatbotState(moreQuestionsMessage);
    };
    handleRequestMoney3 = () => {
      const handleRequestMoney3 = this.createChatBotMessage(parse('There may be a fee from your bank or credit union for using <em>Interac</em> e-Transfer Request Money. Please contact your bank or credit union directly.'));
      this.updateChatbotState(handleRequestMoney3);

      const moreQuestionsMessage = this.createChatBotMessage(parse('Is there anything else I can help with?'),
        {
          widget: 'MoreQuestions',
        }
      );
      this.updateChatbotState(moreQuestionsMessage);
    };
    
    handleIntlTransfersOptions = () => {
      //window.open('https://www.interac.ca/en/consumers/products/interac-e-transfer/international-money-transfer/', '_blank');
      const message = this.createChatBotMessage(
        'What kind of question do you have?',
        {
          widget: 'IntlTransfersOptions',
        }
      );
  
      this.updateChatbotState(message);
    };

    handleIntlTransfersOptions1 = () => {
      const handleIntlTransfersOptions1 = this.createChatBotMessage('You can send money to more than 75* countries worldwide from your Canadian bank account. For current list of countries, please contact your financial institution.');
      this.updateChatbotState(handleIntlTransfersOptions1);

      const moreQuestionsMessage = this.createChatBotMessage(parse('Is there anything else I can help with?'),
        {
          widget: 'MoreQuestions',
        }
      );
      this.updateChatbotState(moreQuestionsMessage);
    };

    handleIntlTransfersOptions2 = () => {
      const handleIntlTransfersOptions2 = this.createChatBotMessage(parse('You can send money internationally in for easy steps: <ol><li>Log In: Log in to online or mobile banking.</li>  <li>Select “Send Money” > International: Select the recipient’s destination and banking information.</li> <li>Request Processing: Your request is sent to the recipient and the will receive a notification via email when the funds have been sent.</li> <li>Request Fulfilled: Funds are directly sent to the recipient’s bank account.</li></ol>'));
      this.updateChatbotState(handleIntlTransfersOptions2);

      const moreQuestionsMessage = this.createChatBotMessage(parse('Is there anything else I can help with?'),
        {
          widget: 'MoreQuestions',
        }
      );
      this.updateChatbotState(moreQuestionsMessage);
    };
    handleIntlTransfersOptions3 = () => {
      const handleIntlTransfersOptions3 = this.createChatBotMessage('An IBAN number is an International Bank Account Number and it is required in order to send/receive money with International Transfer by Mastercard and Interac.');
      this.updateChatbotState(handleIntlTransfersOptions3);

      const moreQuestionsMessage = this.createChatBotMessage(parse('Is there anything else I can help with?'),
        {
          widget: 'MoreQuestions',
        }
      );
      this.updateChatbotState(moreQuestionsMessage);
    };

    handleIntlTransfersOptions4 = () => {
      const handleIntlTransfersOptions4 = this.createChatBotMessage('Please contact your financial institution for information for details.');
      this.updateChatbotState(handleIntlTransfersOptions4);

      const moreQuestionsMessage = this.createChatBotMessage(parse('Is there anything else I can help with?'),
        {
          widget: 'MoreQuestions',
        }
      );
      this.updateChatbotState(moreQuestionsMessage);
    };

    handleIntlTransfersOptions5 = () => {
      const handleIntlTransfersOptions5 = this.createChatBotMessage('The currency exchange rates that apply are the current daily rate posted by your financial institution. When initiating the transfer, you know what to expect before sending, with no hidden fees or exchange rate adjustments mid-transfer. The amount you see is the amount you send, all built in one number with zero surprises.');
      this.updateChatbotState(handleIntlTransfersOptions5);

      const moreQuestionsMessage = this.createChatBotMessage(parse('Is there anything else I can help with?'),
        {
          widget: 'MoreQuestions',
        }
      );
      this.updateChatbotState(moreQuestionsMessage);
    };
    
    handleetransferSecurity = () => {
      //window.open('https://www.interac.ca/en/consumers/security/interac-e-transfer/', '_blank');
      const message = this.createChatBotMessage(
        'What kind of question do you have?',
        {
          widget: 'EtransferSecurityOptions',
        }
      );
  
      this.updateChatbotState(message);
    };

    handleEtransferSecurityOptions1 = () => {
      const handleEtransferSecurityOptions1 = this.createChatBotMessage(parse('Phishing is a scam where fraudsters attempt to acquire personal and/or financial information like passwords, card numbers, etc., by masquerading as a trustworthy person or business through electronic communications. Phishing is typically carried out using email or an instant message, although phone contact has been used as well. In some instances, the fraudster sends authentic-looking emails or text messages (smishing) that appear to come from legitimate companies, requesting recipients to disclose personal and/or financial information that is later used to commit <em>Interac</em>. Be suspicious if you receive a notification you weren’t expecting that money has been sent via <em>Interac</em> e–Transfer. Contact the sender to confirm. If you can’t confirm, please forward the notification to <a href="mailto:phishing@interac.ca">phishing@interac.ca</a> immediately.'));
      this.updateChatbotState(handleEtransferSecurityOptions1);

      const moreQuestionsMessage = this.createChatBotMessage(parse('Is there anything else I can help with?'),
        {
          widget: 'MoreQuestions',
        }
      );
      this.updateChatbotState(moreQuestionsMessage);
    };

    handleEtransferSecurityOptions2 = () => {
      const handleEtransferSecurityOptions2 = this.createChatBotMessage('No. Interac does not hire transfer agents. There have been instances of employment recruitment scams in which Canadian job hunters are hired as agents for “foreign companies”. In fact, the job hunters may actually end up being used as “mules” to transfer stolen funds outside of Canada. Anyone who participates, even unknowingly, could be deemed an accomplice to a crime and may be prosecuted. We urge you to fully investigate any such job offers.');
      this.updateChatbotState(handleEtransferSecurityOptions2);

      const moreQuestionsMessage = this.createChatBotMessage(parse('Is there anything else I can help with?'),
        {
          widget: 'MoreQuestions',
        }
      );
      this.updateChatbotState(moreQuestionsMessage);
    };
    handleEtransferSecurityOptions3 = () => {
      const handleEtransferSecurityOptions3 = this.createChatBotMessage(parse('In the typical scenario, the “employer” poses on job recruitment websites as a legitimate foreign company looking for an agent to represent them in Canada. The job is to accept payment from Canadian customers and transfer proceeds offshore. The employer indicates that a key qualification is to have access to an online bank account and receive <em>Interac</em> e-Transfer funds. Once the employee receives the funds, he or she is instructed to transfer the money via a wire transfer service. As compensation, the employee or “transfer agent” is paid a percentage of the funds. This is often a front for an illegal operation.'));
      this.updateChatbotState(handleEtransferSecurityOptions3);

      const moreQuestionsMessage = this.createChatBotMessage(parse('Is there anything else I can help with?'),
        {
          widget: 'MoreQuestions',
        }
      );
      this.updateChatbotState(moreQuestionsMessage);
    };

    handleEtransferSecurityOptions4 = () => {
      const handleEtransferSecurityOptions4 = this.createChatBotMessage('You may receive employment agreements, websites and other types of official information. While these websites and employment agreements appear legitimate, often they are not.');
      this.updateChatbotState(handleEtransferSecurityOptions4);

      const moreQuestionsMessage = this.createChatBotMessage(parse('Is there anything else I can help with?'),
        {
          widget: 'MoreQuestions',
        }
      );
      this.updateChatbotState(moreQuestionsMessage);
    };

    handleSupport = () => {
      const message = this.createChatBotMessage(
        'How can we offer help?',
        {
          widget: 'EtransferSupport',
        }
      );
  
      this.updateChatbotState(message);
    };

    handleDebit = () => {
      const message = this.createChatBotMessage(
        'What kind of question do you have?',
        {
          widget: 'DebitOptions',
        }
      );
  
      this.updateChatbotState(message);
    };

    handleContactlessPayments = () => {
      //window.open('https://www.interac.ca/en/consumers/products/interac-debit/interac-flash/', '_blank');
      const user_message = this.createChatBotMessage(
        'Contactless Payments',
      );
      const message = this.createChatBotMessage(
        'What kind of question do you have?',
        {
          widget: 'ContactlessPaymentsOptions',
        }
      );
      this.updateChatbotState(user_message);
      this.updateChatbotState(message);
    };

    handleContactlessPayments1 = () => {
      const handleContactlessPayments1 = this.createChatBotMessage(parse('<em>Interac</em> Debit Chip and PIN and contactless transactions are approved by your bank or credit union through secure online systems in real-time. Transactions appear instantly on your bank account records, allowing you to monitor your available balance so you can keep track of your spending.'));
      this.updateChatbotState(handleContactlessPayments1);

      const moreQuestionsMessage = this.createChatBotMessage(parse('Is there anything else I can help with?'),
        {
          widget: 'MoreQuestions',
        }
      );
      this.updateChatbotState(moreQuestionsMessage);
    };
    handleContactlessPayments2 = () => {
      const handleContactlessPayments2 = this.createChatBotMessage(parse('Security is important to us. Chip-enabled <em>Interac</em> Debit and contactless enabled cards are extremely secure and protected from fraud tactics such as skimming, duplicating and electronic pickpocketing. When you make a payment, the only data transmitted consists of payment transaction codes, not confidential details about your bank account. Transactions occur in real time, so no information can be captured by criminals to conduct fraudulent transactions or commit identity theft.'));
      this.updateChatbotState(handleContactlessPayments2);

      const moreQuestionsMessage = this.createChatBotMessage(parse('Is there anything else I can help with?'),
        {
          widget: 'MoreQuestions',
        }
      );
      this.updateChatbotState(moreQuestionsMessage);
    };
    handleContactlessPayments3 = () => {
      const handleContactlessPayments3 = this.createChatBotMessage(parse('<em>Interac</em> Debit Chip and PIN and contactless payments are extremely secure with sophisticated safeguards and fraud detection tools in place to protect you. You are also protected from any losses due to unauthorized transactions under the <em>Interac</em> Zero Liability Policy. If your card is lost or stolen, contact your bank or credit union right away.'));
      this.updateChatbotState(handleContactlessPayments3);

      const moreQuestionsMessage = this.createChatBotMessage(parse('Is there anything else I can help with?'),
        {
          widget: 'MoreQuestions',
        }
      );
      this.updateChatbotState(moreQuestionsMessage);
    };
    handleContactlessPayments4 = () => {
      const handleContactlessPayments4 = this.createChatBotMessage(parse('While there are multiple safeguards in place, as an <em>Interac</em> debit cardholder, you also play an important role in protecting yourself from fraud: Only you should use your <em>Interac</em> debit card or mobile device to make purchases. Choose a PIN that’s difficult for others to guess, avoiding obvious numbers like your telephone number or birthdate, and don’t share it with anyone. Check your bank statements regularly and immediately report any unusual activity to your bank or credit union. If your card is lost or stolen, contact your bank or credit union right away.'));
      this.updateChatbotState(handleContactlessPayments4);

      const moreQuestionsMessage = this.createChatBotMessage(parse('Is there anything else I can help with?'),
        {
          widget: 'MoreQuestions',
        }
      );
      this.updateChatbotState(moreQuestionsMessage);
    };

    handleTransitOpenPayments = () => {
      const user_message = this.createChatBotMessage(
        'Transit Open Payments',
      );
      const message = this.createChatBotMessage(
        'What kind of question do you have?',
        {
          widget: 'TransitOpenPaymentsOptions',
        }
      );
      this.updateChatbotState(user_message);
      this.updateChatbotState(message);
    };
    handleTransit1 = () => {
      const handleTransit1 = this.createChatBotMessage(parse('Transit Open Payments or open payment fare systems provide the ability for transit riders to tap a payment card or a mobile wallet at fare readers without the need to use a transit fare card or transit app to pay for their fare. Interac is enabling the ability for a debit card or mobile wallet supported by <em>Interac</em><sup>&reg;</sup> Debit to be used for this purpose.'));
      this.updateChatbotState(handleTransit1);

      const moreQuestionsMessage = this.createChatBotMessage(parse('Is there anything else I can help with?'),
        {
          widget: 'MoreQuestions',
        }
      );
      this.updateChatbotState(moreQuestionsMessage);
    };
    handleTransit2 = () => {
      const handleTransit2 = this.createChatBotMessage(parse('The ability to pay for transit directly via <em>Interac</em> Debit is available by Metrolinx on the UP Express in Toronto and TransLink in Vancouver.Additional transit authorities across the GTHA have recently been added including GO Transit, Brampton Transit, Burlington Transit, Durham Region Transit, Hamilton Street Railway, MiWay in Mississauga, Oakville Transit, York Region Transit, Para Transpo in Ottawa and more to come.'));
      this.updateChatbotState(handleTransit2);

      const moreQuestionsMessage = this.createChatBotMessage(parse('Is there anything else I can help with?'),
        {
          widget: 'MoreQuestions',
        }
      );
      this.updateChatbotState(moreQuestionsMessage);
    };
    handleTransit3 = () => {
      const handleTransit3 = this.createChatBotMessage(parse('<p>While many large cities internationally have implemented support for Transit Open Payments, implementation plans are based on transit authorities, municipalities, and government agencies. Interac is exploring Transit Open Payments with a number of transit authorities across Canada.</p>  <p>To learn more about Transit Open Payments availability in your area, please reach out to your local transit authority.</p>'));
      this.updateChatbotState(handleTransit3);

      const moreQuestionsMessage = this.createChatBotMessage(parse('Is there anything else I can help with?'),
        {
          widget: 'MoreQuestions',
        }
      );
      this.updateChatbotState(moreQuestionsMessage);
    };
    handleTransit4 = () => {
      const handleTransit4 = this.createChatBotMessage(parse('It is at the discretion of the transit authority (and/or the municipalities served or associated government agencies) to determine payment options available to transit system users. Please reach out to your transit authority for more information.'));
      this.updateChatbotState(handleTransit4);

      const moreQuestionsMessage = this.createChatBotMessage(parse('Is there anything else I can help with?'),
        {
          widget: 'MoreQuestions',
        }
      );
      this.updateChatbotState(moreQuestionsMessage);
    };
    handleTransit5 = () => {
      const handleTransit5 = this.createChatBotMessage(parse('<p>When using Interac Debit, the price of the trip will vary depending on how you travel.</p></p>On GO Transit and UP Express, the fare will be based on the distance of the trip. When customers pay with Interac Debit on GO Transit or UP Express, they will be charged a temporary pre-authorization amount that may be more than the cost of the expected trip – customers should make sure they have sufficient funds on their Interac Debit to cover the pre-authorization.</p><p>The difference between the exact fare and the pre-authorization amount will be returned by your bank.</p></p>On all participating 905-region transit systems in the GTHA, customers will be charged one flat fare.</p>'));
      this.updateChatbotState(handleTransit5);

      const moreQuestionsMessage = this.createChatBotMessage(parse('Is there anything else I can help with?'),
        {
          widget: 'MoreQuestions',
        }
      );
      this.updateChatbotState(moreQuestionsMessage);
    };
    handleTransit6 = () => {
      const handleTransit6 = this.createChatBotMessage(parse('You can contact the transit authority directly with questions about payments made on transit using <em>Interac</em> Debit.'));
      this.updateChatbotState(handleTransit6);

      const moreQuestionsMessage = this.createChatBotMessage(parse('Is there anything else I can help with?'),
        {
          widget: 'MoreQuestions',
        }
      );
      this.updateChatbotState(moreQuestionsMessage);
    };
    handleTransit7 = () => {
      const handleTransit7 = this.createChatBotMessage(parse('<p>To pay your fare, you simply tap your payment credential (e.g., debit card or mobile wallet) on the transit fare reader and enter the transit system.</p><p>Transit authorities may deploy a fixed fare or variable fare (e.g., based on distance travelled or time) payment model. Under each payment model, customer rules around tapping upon entry of transit system or transferring vary across transit authorities. Please contact your local transit authority for information. The transit authority will automatically calculate the fare and process it through your financial institution, normally the same day or by the next day.</p>'));
      this.updateChatbotState(handleTransit7);

      const moreQuestionsMessage = this.createChatBotMessage(parse('Is there anything else I can help with?'),
        {
          widget: 'MoreQuestions',
        }
      );
      this.updateChatbotState(moreQuestionsMessage);
    };

    handleecommercePayments = () => {
      const user_message = this.createChatBotMessage(
        'e-Commerce Payments',
      );
      const message = this.createChatBotMessage(
        'Which product can we help you with?',
        {
          widget: 'EcommercePaymentsOptions',
        }
      );
      this.updateChatbotState(user_message);
      this.updateChatbotState(message);
    };

    handleApplePay = () => {
      const user_message = this.createChatBotMessage(
        'Apple Pay',
      );
      const message = this.createChatBotMessage(
        'What kind of question do you have?',
        {
          widget: 'ApplePayOptions',
        }
      );
      this.updateChatbotState(user_message);
      this.updateChatbotState(message);
    };

    handleApplePay1 = () => {
      const handleApplePay1 = this.createChatBotMessage(parse('<em>Interac</em> Debit on Apple Pay is a new way to make debit payments using <em>Interac</em> Debit on your eligible Apple device. <em>Interac</em> Debit eCommerce payments are the easy, fast, and secure way for Canadians to pay directly from their bank account when shopping online using their mobile device. An in-app payment takes place within the merchant’s native mobile app. An in-browser payment takes place within a supported mobile browser (i.e Safari).'));
      this.updateChatbotState(handleApplePay1);

      const moreQuestionsMessage = this.createChatBotMessage(parse('Is there anything else I can help with?'),
        {
          widget: 'MoreQuestions',
        }
      );
      this.updateChatbotState(moreQuestionsMessage);
    };
    handleApplePay2 = () => {
      const handleApplePay2 = this.createChatBotMessage(parse('<em>Interac</em> Debit cardholders with a debit card issued from participating financial institutions can use <em>Interac</em> Debit to pay with Apple Pay at merchants who accept contactless payments.'));
      this.updateChatbotState(handleApplePay2);

      const moreQuestionsMessage = this.createChatBotMessage(parse('Is there anything else I can help with?'),
        {
          widget: 'MoreQuestions',
        }
      );
      this.updateChatbotState(moreQuestionsMessage);
    };
    handleApplePay3 = () => {
      const handleApplePay3 = this.createChatBotMessage(parse('<em>Interac</em> debit cards issued by participating financial institutions are eligible to be added to Apple Pay. Please check with your financial institution for more details.'));
      this.updateChatbotState(handleApplePay3);

      const moreQuestionsMessage = this.createChatBotMessage(parse('Is there anything else I can help with?'),
        {
          widget: 'MoreQuestions',
        }
      );
      this.updateChatbotState(moreQuestionsMessage);
    };
    handleApplePay4 = () => {
      const handleApplePay4 = this.createChatBotMessage(parse('You can use <em>Interac</em> Debit on Apple Pay to make payments in stores with supported devices wherever <em>Interac</em> Flash payments are accepted. Just look for the contactless symbol at checkout.<br />You can also use <em>Interac</em> Debit on Apple Pay for eCommerce transactions to make a purchase within the mobile application or mobile website of select merchants who have integrated with Apple Pay. We are continuously working to onboard more issuers and merchants to support <em>Interac</em> Debit with Apple Pay.'));
      this.updateChatbotState(handleApplePay4);

      const moreQuestionsMessage = this.createChatBotMessage(parse('Is there anything else I can help with?'),
        {
          widget: 'MoreQuestions',
        }
      );
      this.updateChatbotState(moreQuestionsMessage);
    };
    handleApplePay5 = () => {
      const handleApplePay5 = this.createChatBotMessage(parse('For instructions on how to add an <em>Interac</em> debit card to a mobile wallet, please visit the <em>Interac</em> Apple Pay page. For your debit card to be accepted as a method of payment, your financial institution needs to be a participating issuer.<br />Note: To enable <em>Interac</em> Debit transactions in merchant apps or mobile websites, you will need to add your <em>Interac</em> Debit card to your Apple Pay wallet first.'));
      this.updateChatbotState(handleApplePay5);

      const moreQuestionsMessage = this.createChatBotMessage(parse('Is there anything else I can help with?'),
        {
          widget: 'MoreQuestions',
        }
      );
      this.updateChatbotState(moreQuestionsMessage);
    };
    handleGooglePay = () => {
      const user_message = this.createChatBotMessage(
        'Google Pay',
      );
      const message = this.createChatBotMessage(
        'What kind of question do you have?',
        {
          widget: 'GooglePayOptions',
        }
      );
      this.updateChatbotState(user_message);
      this.updateChatbotState(message);
    };
    handleGooglePay1 = () => {
      const handleGooglePay1 = this.createChatBotMessage(parse('<em>Interac</em> Debit on Google Pay is an easy way to make payments using your eligible Android device.<br /><em>Interac</em> Debit eCommerce payments are the easy, fast, and secure way for Canadians to pay directly from their bank account when shopping online using their mobile device. An in-app payment takes place within the merchant’s native mobile app. An in-browser payment takes place within a supported mobile browser (i.e Chrome).'));
      this.updateChatbotState(handleGooglePay1);

      const moreQuestionsMessage = this.createChatBotMessage(parse('Is there anything else I can help with?'),
        {
          widget: 'MoreQuestions',
        }
      );
      this.updateChatbotState(moreQuestionsMessage);
    };
    handleGooglePay2 = () => {
      const handleGooglePay2 = this.createChatBotMessage(parse('<em>Interac</em> Debit cardholders with a debit card issued from participating financial institutions can use <em>Interac</em> Debit to pay with Google Pay at merchants who accept contactless payments.<br />For <em>Interac</em> Debit with Google Pay transactions, <em>Interac</em> Debit cardholders with a debit card issued from participating financial institutions can pay on select merchant applications or mobile websites using Google Pay. We are continuously working to onboard more issuers and merchants to support <em>Interac</em> Debit with Google Pay.'));
      this.updateChatbotState(handleGooglePay2);

      const moreQuestionsMessage = this.createChatBotMessage(parse('Is there anything else I can help with?'),
        {
          widget: 'MoreQuestions',
        }
      );
      this.updateChatbotState(moreQuestionsMessage);
    };
    handleGooglePay3 = () => {
      const handleGooglePay3 = this.createChatBotMessage(parse('<em>Interac</em> debit cards issued by participating financial institutions are eligible to be added to Google Pay. Please check with your financial institution for more details. For <em>Interac</em> Debit with Google Pay transactions, an <em>Interac</em> debit cards from a participating financial institution must first be provisioned to the mobile device (within the mobile wallet) before it can be used within a participating merchant application or mobile website.'));
      this.updateChatbotState(handleGooglePay3);

      const moreQuestionsMessage = this.createChatBotMessage(parse('Is there anything else I can help with?'),
        {
          widget: 'MoreQuestions',
        }
      );
      this.updateChatbotState(moreQuestionsMessage);
    };
    handleGooglePay4 = () => {
      const handleGooglePay4 = this.createChatBotMessage('Google Pay may be preloaded on select Google devices. If your device does not have the app, simply download it from Google Play Store.');
      this.updateChatbotState(handleGooglePay4);

      const moreQuestionsMessage = this.createChatBotMessage(parse('Is there anything else I can help with?'),
        {
          widget: 'MoreQuestions',
        }
      );
      this.updateChatbotState(moreQuestionsMessage);
    };
    handleGooglePay5 = () => {
      const handleGooglePay5 = this.createChatBotMessage(parse('This message means that Google has not updated your device yet which is affecting your ability to add your debit card. Google will send you an email and you will receive a notification on your device when it has been updated. You will then be able to add your debit card from a participating financial institution to use <em>Interac</em> Debit on Google Pay.'));
      this.updateChatbotState(handleGooglePay5);
      
      const moreQuestionsMessage = this.createChatBotMessage(parse('Is there anything else I can help with?'),
        {
          widget: 'MoreQuestions',
        }
      );
      this.updateChatbotState(moreQuestionsMessage);
    };

    handleSamsungPay = () => {
      const user_message = this.createChatBotMessage(
        'Samsung Pay',
      );
      const message = this.createChatBotMessage(
        'What kind of question do you have?',
        {
          widget: 'SamsungPayOptions',
        }
      );
      this.updateChatbotState(user_message);
      this.updateChatbotState(message);
    };

    handleSamsungPay1 = () => {
      const handleSamsungPay1 = this.createChatBotMessage(parse('<em>Interac</em> Debit on Samsung Pay is an easy way for consumers withparse( <em>Interac</em> debit cards issued by participating financial institutions to make fast and secure mobile contactless payments using Samsung Pay.'));
      this.updateChatbotState(handleSamsungPay1);

      const moreQuestionsMessage = this.createChatBotMessage(parse('Is there anything else I can help with?'),
        {
          widget: 'MoreQuestions',
        }
      );
      this.updateChatbotState(moreQuestionsMessage);
    };
    handleSamsungPay2 = () => {
      const handleSamsungPay2 = this.createChatBotMessage(parse('Canadian <em>Interac</em> debit cardholders can now use an eligible debit card from their participating financial institutions with Samsung Pay to pay at stores that accept contactless payments.'));
      this.updateChatbotState(handleSamsungPay2);

      const moreQuestionsMessage = this.createChatBotMessage(parse('Is there anything else I can help with?'),
        {
          widget: 'MoreQuestions',
        }
      );
      this.updateChatbotState(moreQuestionsMessage);
    };
    handleSamsungPay3 = () => {
      const handleSamsungPay3 = this.createChatBotMessage(parse('At this time, <em>Interac</em> debit cards issued by Canadian participating financial institutions are eligible to be added to Samsung Pay. Please check with your financial institution for more details.<br />Samsung Pay works on most Samsung NFC-capable devices. NFC-capable devices enable you to make purchases at merchants who displays the contactless symbol at checkout.'));
      this.updateChatbotState(handleSamsungPay3);

      const moreQuestionsMessage = this.createChatBotMessage(parse('Is there anything else I can help with?'),
        {
          widget: 'MoreQuestions',
        }
      );
      this.updateChatbotState(moreQuestionsMessage);
    };
    handleSamsungPay4 = () => {
      const handleSamsungPay4 = this.createChatBotMessage(parse('You can use <em>Interac</em> Debit on Samsung Pay to make payments in stores with supported terminals wherever contactless payments are accepted.'));
      this.updateChatbotState(handleSamsungPay4);

      const moreQuestionsMessage = this.createChatBotMessage(parse('Is there anything else I can help with?'),
        {
          widget: 'MoreQuestions',
        }
      );
      this.updateChatbotState(moreQuestionsMessage);
    };
    handleSamsungPay5 = () => {
      const handleSamsungPay5 = this.createChatBotMessage(parse('Add an eligible participating financial institution’s <em>Interac</em> debit card to Samsung Pay by opening the Samsung Pay app on your eligible device and signing into your Samsung Account. Enter a pin, so you can authenticate future purchases. Next, use your device camera to recognize your <em>Interac</em> debit card or enter the card details manually. Then, enter any additional information as required. For security reasons, a verification step may be needed to enable your virtual card. If you have a co-badged card (<em>Interac</em> logo and another payment brand’s debit logo on front of bank card), you will need to enter your Security Code (CVV) and accept your financial institution’s Terms of Use for Samsung Pay when you add the card to Samsung Pay. You may also be subject to your financial institution’s or Samsung’s own terms & conditions.'));
      this.updateChatbotState(handleSamsungPay5);

      const moreQuestionsMessage = this.createChatBotMessage(parse('Is there anything else I can help with?'),
        {
          widget: 'MoreQuestions',
        }
      );
      this.updateChatbotState(moreQuestionsMessage);
    };

    handleOnlinePayments = () => {
      const user_message = this.createChatBotMessage(
        'Samsung Pay',
      );
      const message = this.createChatBotMessage(
        'What kind of question do you have?',
        {
          widget: 'OnlinePaymentsOptions',
        }
      );
      this.updateChatbotState(user_message);
      this.updateChatbotState(message);
    };

    handleOnlinePayments1 = () => {
      const handleOnlinePayments1 = this.createChatBotMessage(parse('Please contact your bank or credit union to troubleshoot any transactions. The contact information is usually on the back of your <em>Interac</em> debit card.'));
      this.updateChatbotState(handleOnlinePayments1);

      const moreQuestionsMessage = this.createChatBotMessage(parse('Is there anything else I can help with?'),
        {
          widget: 'MoreQuestions',
        }
      );
      this.updateChatbotState(moreQuestionsMessage);
    };
    handleOnlinePayments2 = () => {
      const handleOnlinePayments2 = this.createChatBotMessage('Please contact your participating bank or credit union to inquire about your limits.');
      this.updateChatbotState(handleOnlinePayments2);

      const moreQuestionsMessage = this.createChatBotMessage(parse('Is there anything else I can help with?'),
        {
          widget: 'MoreQuestions',
        }
      );
      this.updateChatbotState(moreQuestionsMessage);
    };
    handleOnlinePayments3 = () => {
      const handleOnlinePayments3 = this.createChatBotMessage(parse('Your <em>Interac</em> Debit for online payments are handled by your bank or credit union, which would be the one to charge fees, if there are any. Contact your participating bank or credit union for further information.'));
      this.updateChatbotState(handleOnlinePayments3);

      const moreQuestionsMessage = this.createChatBotMessage(parse('Is there anything else I can help with?'),
        {
          widget: 'MoreQuestions',
        }
      );
      this.updateChatbotState(moreQuestionsMessage);
    };
    handleOnlinePayments4 = () => {
      const handleOnlinePayments4 = this.createChatBotMessage('It’s easy to get access to online banking. Your bank or credit union can help you. Visit their website to sign up, or contact them directly for details.');
      this.updateChatbotState(handleOnlinePayments4);

      const moreQuestionsMessage = this.createChatBotMessage(parse('Is there anything else I can help with?'),
        {
          widget: 'MoreQuestions',
        }
      );
      this.updateChatbotState(moreQuestionsMessage);
    };
    handleOnlinePayments5 = () => {
      const handleOnlinePayments5 = this.createChatBotMessage(parse('If you have questions or concerns about your online purchase (e.g., delivery time, shipping options, product information, etc.), please contact the retailer. If you have questions or concerns about your <em>Interac</em> Debit for online payments (e.g., fees, limits, your account, processing times, etc.) that cannot be answered by the merchant, please contact your bank. In a proven case of online fraud, you are protected by the <em>Interac</em> Zero Liability Policy, which ensures that your funds are returned to your bank account by your financial institution.'));
      this.updateChatbotState(handleOnlinePayments5);

      const moreQuestionsMessage = this.createChatBotMessage(parse('Is there anything else I can help with?'),
        {
          widget: 'MoreQuestions',
        }
      );
      this.updateChatbotState(moreQuestionsMessage);
    };
    handleOnlinePayments6 = () => {
      const handleOnlinePayments6 = this.createChatBotMessage(parse('If you reach the confirmation screen and receive a confirmation number, your payment was completed. If you confirmed your payment in online banking, but did not get redirected to a confirmation page on the online retailer’s website, one of two things may have happened: <ol><li>1. The online retailer received your payment, but for some reason you were unable to see the confirmation page. If you receive a confirmation email or are able to view the transaction in your order history on the retailer’s website, this was likely the case.</li> <li>2. The online retailer was not able to receive your payment. If this was the case, your payment will be re-credited to your account within minutes. You can also contact the online retailer to confirm whether your order has been processed.</li></ol>'));
      this.updateChatbotState(handleOnlinePayments6);

      const moreQuestionsMessage = this.createChatBotMessage(parse('Is there anything else I can help with?'),
        {
          widget: 'MoreQuestions',
        }
      );
      this.updateChatbotState(moreQuestionsMessage);
    };

    handleAbmWithdrawals = () => {
      const user_message = this.createChatBotMessage(
        'ABM Withdrawals',
      );
      const message = this.createChatBotMessage(
        'What kind of question do you have?',
        {
          widget: 'AbmWithdrawalsOptions',
        }
      );
      this.updateChatbotState(user_message);
      this.updateChatbotState(message);
    };

    handleAbmWithdrawals1 = () => {
      const handleAbmWithdrawals1 = this.createChatBotMessage(parse('ABM withdrawals are a convenient way to withdraw cash from your account at any Automated Banking Machine (ABM) displaying the <em>Interac</em> logo, anywhere in Canada. <em>Interac</em> has made accessing your account for cash withdrawals convenient with more than 70,0000 ABMs available across Canada, many of which are available 24 hours a day.'));
      this.updateChatbotState(handleAbmWithdrawals1);

      const moreQuestionsMessage = this.createChatBotMessage(parse('Is there anything else I can help with?'),
        {
          widget: 'MoreQuestions',
        }
      );
      this.updateChatbotState(moreQuestionsMessage);
    };
    handleAbmWithdrawals2 = () => {
      const handleAbmWithdrawals2 = this.createChatBotMessage(parse('Please contact your bank or credit union to troubleshoot any ABM transactions. The contact information is usually on the back of your <em>Interac</em> debit card.'));
      this.updateChatbotState(handleAbmWithdrawals2);

      const moreQuestionsMessage = this.createChatBotMessage(parse('Is there anything else I can help with?'),
        {
          widget: 'MoreQuestions',
        }
      );
      this.updateChatbotState(moreQuestionsMessage);
    };
    handleAbmWithdrawals3 = () => {
      const handleAbmWithdrawals3 = this.createChatBotMessage(parse('ABM withdrawals is safe and secure. This is ensured by your chip-enabled card and confidential Personal Identification Number (PIN). Adherence to strict Canadian and international security standards are required by all <em>Interac</em> Network Participants. An <em>Interac</em> debit card cannot be used to withdraw cash at an ABM without the cardholder’s PIN. This ensures the security of funds when a card is lost, stolen, or illegally copied. It’s important to immediately report lost or stolen cards to your bank or credit union to avoid any possible liability.'));
      this.updateChatbotState(handleAbmWithdrawals3);

      const moreQuestionsMessage = this.createChatBotMessage(parse('Is there anything else I can help with?'),
        {
          widget: 'MoreQuestions',
        }
      );
      this.updateChatbotState(moreQuestionsMessage);
    };
    handleAbmWithdrawals4 = () => {
      const handleAbmWithdrawals4 = this.createChatBotMessage(parse('ABM withdrawals allow you to withdraw cash from your account at an ABM. To begin a transaction, insert a valid <em>Interac</em> debit card into any ABM that displays the <em>Interac</em> logo and follow the prompts on the screen: 1. Enter the withdrawal amount 2. Select the account from which you wish to withdraw funds 3. Enter your Personal Identification Number (PIN) 4. Provide a final okay to send the request for the cash withdrawal.'));
      this.updateChatbotState(handleAbmWithdrawals4);

      const moreQuestionsMessage = this.createChatBotMessage(parse('Is there anything else I can help with?'),
        {
          widget: 'MoreQuestions',
        }
      );
      this.updateChatbotState(moreQuestionsMessage);
    };

    handleDebitSupport = () => {
      const message = this.createChatBotMessage(
        'How can we offer help?',
        {
          widget: 'DebitSupport',
        }
      );
  
      this.updateChatbotState(message);
    };


    handleBusinessProducts = () => {
      const message = this.createChatBotMessage(
        'What can we help you with?',
        {
          widget: 'BusinessProducts',
        }
      );
  
      this.updateChatbotState(message);
    };

    handleEtransferBus = () => {
      const message = this.createChatBotMessage(
        'What can we help you with?',
        {
          widget: 'EtransferOptionsBus',
        }
      );
  
      this.updateChatbotState(message);
    };
    handleEufBus = () => {
      const message = this.createChatBotMessage(
        'What can we help you with?',
        {
          widget: 'EufOptionsBus',
        }
      );
  
      this.updateChatbotState(message);
    };

    handleEtransferBus1 = () => {
      const handleEtransferBus1 = this.createChatBotMessage('Please contact your business bank or credit union for any troubleshooting support.');
      this.updateChatbotState(handleEtransferBus1);

      const moreQuestionsMessage = this.createChatBotMessage(parse('Is there anything else I can help with?'),
        {
          widget: 'MoreQuestions',
        }
      );
      this.updateChatbotState(moreQuestionsMessage);
    };
    handleEtransferBus2 = () => {
      const handleEtransferBus2 = this.createChatBotMessage(parse('Yes, you can use <em>Interac</em> e-Transfer for your business invoicing and payment needs if you bank with a participating bank or credit union. You need a Canadian online bank account and an email address or mobile phone number. If you are sending funds via <em>Interac</em> e-Transfer, your recipient will also need an email address or Canadian mobile phone number to receive the funds.'));
      this.updateChatbotState(handleEtransferBus2);

      const moreQuestionsMessage = this.createChatBotMessage(parse('Is there anything else I can help with?'),
        {
          widget: 'MoreQuestions',
        }
      );
      this.updateChatbotState(moreQuestionsMessage);
    };
    handleEtransferBus3 = () => {
      const handleEtransferBus3 = this.createChatBotMessage(parse('Businesses of any size can use <em>Interac</em> e-Transfer to simplify and accelerate payments, from independent consultants, to small businesses to enterprise-level organizations.'));
      this.updateChatbotState(handleEtransferBus3);

      const moreQuestionsMessage = this.createChatBotMessage(parse('Is there anything else I can help with?'),
        {
          widget: 'MoreQuestions',
        }
      );
      this.updateChatbotState(moreQuestionsMessage);
    };
    handleEtransferBus4 = () => {
      const handleEtransferBus4 = this.createChatBotMessage('Fees are set by individual banks and credit unions, please contact your business bank for pricing information.');
      this.updateChatbotState(handleEtransferBus4);

      const moreQuestionsMessage = this.createChatBotMessage(parse('Is there anything else I can help with?'),
        {
          widget: 'MoreQuestions',
        }
      );
      this.updateChatbotState(moreQuestionsMessage);
    };
    
    handleOurSolutions = () => {
      const message = this.createChatBotMessage(
        'Which product are you interested in learning about?',
        {
          widget: 'OurSolutions',
        }
      );
  
      this.updateChatbotState(message);
    };

    handleAutodepositBus = () => {
      const message = this.createChatBotMessage(
        'What can we help you with?',
        {
          widget: 'AutodepositOptionsBus',
        }
      );
  
      this.updateChatbotState(message);
    };
    AutodepositBus1 = () => {
      const AutodepositBus1 = this.createChatBotMessage(parse('You will need to register. Visit our <em>Interac</em> e-Transfer page for more information on how to set up Autodeposit.'));
      this.updateChatbotState(AutodepositBus1);

      const moreQuestionsMessage = this.createChatBotMessage(parse('Is there anything else I can help with?'),
        {
          widget: 'MoreQuestions',
        }
      );
      this.updateChatbotState(moreQuestionsMessage);
    };
    AutodepositBus2 = () => {
      const AutodepositBus2 = this.createChatBotMessage(parse('Visit our <em>Interac</em> e-Transfer for Business security page or speak with your business bank. You can find a list of banks or credit unions offering Autodeposit on our <em>Interac</em> e-Transfer page.'));
      this.updateChatbotState(AutodepositBus2);

      const moreQuestionsMessage = this.createChatBotMessage(parse('Is there anything else I can help with?'),
        {
          widget: 'MoreQuestions',
        }
      );
      this.updateChatbotState(moreQuestionsMessage);
    };
    AutodepositBus3 = () => {
      const AutodepositBus3 = this.createChatBotMessage(parse('The process is simple. Please visit our <em>Interac</em> e-Transfer page for details on how to turn Autodeposit off.'));
      this.updateChatbotState(AutodepositBus3);

      const moreQuestionsMessage = this.createChatBotMessage(parse('Is there anything else I can help with?'),
        {
          widget: 'MoreQuestions',
        }
      );
      this.updateChatbotState(moreQuestionsMessage);
    };
    handleRequestMoneyBus = () => {
      const message = this.createChatBotMessage(
        'Which product are you interested in learning about?',
        {
          widget: 'RequestMoneyOptionsBus',
        }
      );
  
      this.updateChatbotState(message);
    };
    RequestMoneyBus = () => {
      const message = this.createChatBotMessage(
        'What can we help you with?',
        {
          widget: 'RequestMoneyOptionsBus',
        }
    );
  
      this.updateChatbotState(message);
    };
    RequestMoneyBus1 = () => {
      const RequestMoneyBus1 = this.createChatBotMessage(parse('Request Money is an easy-to-use <em>Interac</em> e-Transfer feature that allows you to send a notification to someone that you are asking for payment. It’s a convenient way to bill clients and customers and helps ensure payment is sent to the right source, minimizing the chance that your payment is lost or delayed in the mail, or sent to the wrong account.'));
      this.updateChatbotState(RequestMoneyBus1);

      const moreQuestionsMessage = this.createChatBotMessage(parse('Is there anything else I can help with?'),
        {
          widget: 'MoreQuestions',
        }
      );
      this.updateChatbotState(moreQuestionsMessage);
    };
    RequestMoneyBus2 = () => {
      const RequestMoneyBus2 = this.createChatBotMessage(parse('You can add the invoice number into the message area when sending the <em>Interac</em> e-Transfer Request Money notification to help it function as an invoice. Please note that message characters are limited.'));
      this.updateChatbotState(RequestMoneyBus2);

      const moreQuestionsMessage = this.createChatBotMessage(parse('Is there anything else I can help with?'),
        {
          widget: 'MoreQuestions',
        }
      );
      this.updateChatbotState(moreQuestionsMessage);
    };

    handleBulkDisbursements = () => {
      const message = this.createChatBotMessage(
        'What can we help you with?',
        {
          widget: 'BulkDisbursementsOptions',
        }
    );
  
      this.updateChatbotState(message);
    };
    BulkDisbursements1 = () => {
      const BulkDisbursements1 = this.createChatBotMessage(parse('Bulk disbursements allow you to make multiple payments at once via <em>Interac</em> e-Transfer. It’s can help streamline your payroll and supplier payment system. Please visit our <em>Interac</em> e-Transfer for Business page for more information on how it works.'));
      this.updateChatbotState(BulkDisbursements1);

      const moreQuestionsMessage = this.createChatBotMessage(parse('Is there anything else I can help with?'),
        {
          widget: 'MoreQuestions',
        }
      );
      this.updateChatbotState(moreQuestionsMessage);
    };
    BulkDisbursements2 = () => {
      const BulkDisbursements2 = this.createChatBotMessage(parse('Fees are set by your bank or credit union, please contact your business bank for pricing information. You can also find a list of banks or credit unions offering Bulk Disbursements on our <em>Interac</em> e-Transfer page.'));
      this.updateChatbotState(BulkDisbursements2);

      const moreQuestionsMessage = this.createChatBotMessage(parse('Is there anything else I can help with?'),
        {
          widget: 'MoreQuestions',
        }
      );
      this.updateChatbotState(moreQuestionsMessage);
    };
    BulkDisbursements3 = () => {
      const BulkDisbursements3 = this.createChatBotMessage('Please contact your bank or credit unions offering Bulk Disbursements for a detailed account of the format and methods allowed for submission.');
      this.updateChatbotState(BulkDisbursements3);

      const moreQuestionsMessage = this.createChatBotMessage(parse('Is there anything else I can help with?'),
        {
          widget: 'MoreQuestions',
        }
      );
      this.updateChatbotState(moreQuestionsMessage);
    };
    BulkDisbursements4 = () => {
      const BulkDisbursements4 = this.createChatBotMessage(parse('The time will vary by bank or credit union; <em>Interac</em> starts processing the payments as soon as we receive them from the financial institution.'));
      this.updateChatbotState(BulkDisbursements4);

      const moreQuestionsMessage = this.createChatBotMessage(parse('Is there anything else I can help with?'),
        {
          widget: 'MoreQuestions',
        }
      );
      this.updateChatbotState(moreQuestionsMessage);
    };
    BulkDisbursements5 = () => {
      const BulkDisbursements5 = this.createChatBotMessage(parse('Please contact your business bank or credit union. You can also find a list of participating banks and credit unions on our <em>Interac</em> e-Transfer page.'));
      this.updateChatbotState(BulkDisbursements5);

      const moreQuestionsMessage = this.createChatBotMessage(parse('Is there anything else I can help with?'),
        {
          widget: 'MoreQuestions',
        }
      );
      this.updateChatbotState(moreQuestionsMessage);
    };

    handleDebitBus = () => {
      const message = this.createChatBotMessage(
        'What can we help you with?',
        {
          widget: 'DebitOptionsBus',
        }
      );
  
      this.updateChatbotState(message);
    };
    DebitBus1 = () => {
      const DebitBus1 = this.createChatBotMessage(parse('For any troubleshooting support, please contact your <em>Interac</em> Debit <a href="https://www.interac.ca/en/business/how-it-works/find-an-acquirer/#fi-list-acquirers-interac-debit-service-pos-merchant-services" target="_blank">Acquirer</a>.'));
      this.updateChatbotState(DebitBus1);

      const moreQuestionsMessage = this.createChatBotMessage(parse('Is there anything else I can help with?'),
        {
          widget: 'MoreQuestions',
        }
      );
      this.updateChatbotState(moreQuestionsMessage);
    };
    DebitBus2 = () => {
      const DebitBus2 = this.createChatBotMessage(parse('An Acquirer is a service provider that offers <em>Interac</em> Debit terminals and service to businesses. Please visit our <em>Interac</em> Debit for Business page for a <a href="https://www.interac.ca/en/business/how-it-works/find-an-acquirer/" target="_blank">list of participating Acquirers.</a>.'));
      this.updateChatbotState(DebitBus2);

      const moreQuestionsMessage = this.createChatBotMessage(parse('Is there anything else I can help with?'),
        {
          widget: 'MoreQuestions',
        }
      );
      this.updateChatbotState(moreQuestionsMessage);
    };
    DebitBus3 = () => {
      const DebitBus3 = this.createChatBotMessage(parse('<em>Interac</em> Debit is a payment type that is suitable for all businesses in Canada, no matter the size.'));
      this.updateChatbotState(DebitBus3);

      const moreQuestionsMessage = this.createChatBotMessage(parse('Is there anything else I can help with?'),
        {
          widget: 'MoreQuestions',
        }
      );
      this.updateChatbotState(moreQuestionsMessage);
    };
    DebitBus4 = () => {
      const DebitBus4 = this.createChatBotMessage(parse('You get an <em>Interac</em> Debit point-of-sale terminal through an Acquirer. Acquirers manage all services around <em>Interac</em> Debit. You can find a list of <a href="https://www.interac.ca/en/business/how-it-works/find-an-acquirer/" target="_blank">participating Acquirers</a> on our <em>Interac</em> Debit for Business page.'));
      this.updateChatbotState(DebitBus4);

      const moreQuestionsMessage = this.createChatBotMessage(parse('Is there anything else I can help with?'),
        {
          widget: 'MoreQuestions',
        }
      );
      this.updateChatbotState(moreQuestionsMessage);
    };
    DebitBus5 = () => {
      const DebitBus5 = this.createChatBotMessage(parse('The fees are set by your chosen Acquirer, which includes the fees for Interac services. For more information please visit our <a href="https://www.interac.ca/en/business/support/understanding-fees/" target="_blank">Understanding Fees page</a>. To contact an Acquirer for more fee information, you can find a <a href="https://www.interac.ca/en/business/how-it-works/find-an-acquirer/" target="_blank">list of participating Acquirers</a> on our Interac Debit for Business page.'));
      this.updateChatbotState(DebitBus5);

      const moreQuestionsMessage = this.createChatBotMessage(parse('Is there anything else I can help with?'),
        {
          widget: 'MoreQuestions',
        }
      );
      this.updateChatbotState(moreQuestionsMessage);
    };
    DebitBus6 = () => {
      const DebitBus6 = this.createChatBotMessage(parse('Set-up time and process can vary by individual Acquirer. Please visit our <em>Interac</em> Debit for Business page for a <a href="https://www.interac.ca/en/business/how-it-works/find-an-acquirer/" target="_blank">list of participating Acquirers</a>.'));
      this.updateChatbotState(DebitBus6);

      const moreQuestionsMessage = this.createChatBotMessage(parse('Is there anything else I can help with?'),
        {
          widget: 'MoreQuestions',
        }
      );
      this.updateChatbotState(moreQuestionsMessage);
    };
    handleContactlessBus = () => {
      const message = this.createChatBotMessage(
        'What can we help you with?',
        {
          widget: 'ContactlessOptionsBus',
        }
      );
  
      this.updateChatbotState(message);
    };
    ContactlessBus1 = () => {
      const ContactlessBus1 = this.createChatBotMessage(parse('For any troubleshooting support, please contact your <a href="https://www.interac.ca/en/business/how-it-works/find-an-acquirer/#fi-list-acquirers-interac-debit-service-pos-merchant-services" target="_blank">contactless payment acquirer</a>.'));
      this.updateChatbotState(ContactlessBus1);

      const moreQuestionsMessage = this.createChatBotMessage(parse('Is there anything else I can help with?'),
        {
          widget: 'MoreQuestions',
        }
      );
      this.updateChatbotState(moreQuestionsMessage);
    };
    ContactlessBus2 = () => {
      const ContactlessBus2 = this.createChatBotMessage(parse('Please visit our contactless payments for Business page for information around the benefits, <a href="https://www.interac.ca/en/business/our-solutions/interac-flash/#interac-flash-how-it-works">how it works</a> and a <a href="https://www.interac.ca/en/business/how-it-works/find-an-acquirer/#fi-list-acquirers-interac-debit-service-pos-merchant-services" target="_blank">list of Acquirers</a> to answer more questions.'));
      this.updateChatbotState(ContactlessBus2);

      const moreQuestionsMessage = this.createChatBotMessage(parse('Is there anything else I can help with?'),
        {
          widget: 'MoreQuestions',
        }
      );
      this.updateChatbotState(moreQuestionsMessage);
    };
    ContactlessBus3 = () => {
      const ContactlessBus3 = this.createChatBotMessage(parse('This depends on the type of terminal you currently have. The majority of terminals in market offer contactless payment capability. Please contact your Acquirer to inquire as to whether your terminal is ready to offer contactless payment.'));
      this.updateChatbotState(ContactlessBus3);

      const moreQuestionsMessage = this.createChatBotMessage(parse('Is there anything else I can help with?'),
        {
          widget: 'MoreQuestions',
        }
      );
      this.updateChatbotState(moreQuestionsMessage);
    };
    ContactlessBus4 = () => {
      const ContactlessBus4 = this.createChatBotMessage(parse('The fees are set by your chosen Acquirer, which includes the fees for Interac services. For more information please visit our <a href="https://www.interac.ca/en/business/support/understanding-fees/" target="_blank">Understanding Fees</a> page. To contact an Acquirer for more fee information, you can find a <a href="https://www.interac.ca/en/business/how-it-works/find-an-acquirer/#fi-list-acquirers-interac-debit-service-pos-merchant-services" target="_blank">list of participating Acquirers</a> on our <em>Interac</em> Debit for Business page.'));
      this.updateChatbotState(ContactlessBus4);

      const moreQuestionsMessage = this.createChatBotMessage(parse('Is there anything else I can help with?'),
        {
          widget: 'MoreQuestions',
        }
      );
      this.updateChatbotState(moreQuestionsMessage);
    };
    ContactlessBus5 = () => {
      const ContactlessBus5 = this.createChatBotMessage(parse('Transaction limits are set at $100 per transaction. There is also added protection of a cumulative contactless limit set by individual banks or credit unions.  A cumulative limit is the maximum contactless spend limit that can be done by an individual <em>Interac</em> debit card before the user is promoted to reset the limit with a Chip and PIN transaction. This confirms that you are the authorized cardholder.'));
      this.updateChatbotState(ContactlessBus5);

      const moreQuestionsMessage = this.createChatBotMessage(parse('Is there anything else I can help with?'),
        {
          widget: 'MoreQuestions',
        }
      );
      this.updateChatbotState(moreQuestionsMessage);
    };
    ContactlessBus6 = () => {
      const ContactlessBus6 = this.createChatBotMessage(parse('Please see our Contactless Payments for Business <a href="https://www.interac.ca/en/business/safety-and-security/interac-debit/">security page</a> for information around security and protections such as the <em>Interac</em> Zero Liability Policy.'));
      this.updateChatbotState(ContactlessBus6);

      const moreQuestionsMessage = this.createChatBotMessage(parse('Is there anything else I can help with?'),
        {
          widget: 'MoreQuestions',
        }
      );
      this.updateChatbotState(moreQuestionsMessage);
    };
    handleMobileBus = () => {
      const message = this.createChatBotMessage(
        'What can we help you with?',
        {
          widget: 'MobileOptionsBus',
        }
      );
  
      this.updateChatbotState(message);
    };
    MobileBus1 = () => {
      const MobileBus1 = this.createChatBotMessage(parse('<em>Interac</em> Debit for mobile is a point-of-sale payment solution that works with Apple Pay, Google Pay and Samsung Pay. For more information around how it works and to find a list of participating Acquirers, please visit our <em>Interac</em> Debit on Mobile for Business page.'));
      this.updateChatbotState(MobileBus1);
      const moreQuestionsMessage = this.createChatBotMessage(parse('Is there anything else I can help with?'),
        {
          widget: 'MoreQuestions',
        }
      );
      this.updateChatbotState(moreQuestionsMessage);
    };
    MobileBus2 = () => {
      const MobileBus2 = this.createChatBotMessage(parse('If you already offer <em>Interac</em> Debit contactless payments to your customer, no further set up that is required.  Contact your Acquirer for more information. You can also find a <a href="https://www.interac.ca/en/business/how-it-works/find-an-acquirer/#fi-list-acquirers-interac-debit-service-pos-merchant-services" target="_blank">list of participating Acquirers</a> on our <em>Interac</em> Debit on Mobile for Business page.'));
      this.updateChatbotState(MobileBus2);
      const moreQuestionsMessage = this.createChatBotMessage(parse('Is there anything else I can help with?'),
        {
          widget: 'MoreQuestions',
        }
      );
      this.updateChatbotState(moreQuestionsMessage);
    };
    MobileBus3 = () => {
      const MobileBus3 = this.createChatBotMessage(parse('For troubleshooting support, please contact your <em>Interac</em> Debit <a href="https://www.interac.ca/en/business/how-it-works/find-an-acquirer/#fi-list-acquirers-interac-debit-service-pos-merchant-services" target="_blank">Acquirer</a>.'));
      this.updateChatbotState(MobileBus3);
      const moreQuestionsMessage = this.createChatBotMessage(parse('Is there anything else I can help with?'),
        {
          widget: 'MoreQuestions',
        }
      );
      this.updateChatbotState(moreQuestionsMessage);
    };
    handleOnlinePaymentsBus = () => {
      const message = this.createChatBotMessage(
        'What can we help you with?',
        {
          widget: 'OnlineOptionsBus',
        }
      );
  
      this.updateChatbotState(message);
    };
    OnlineBus1 = () => {
      const OnlineBus1 = this.createChatBotMessage(parse('For any troubleshooting support, please contact your <em>Interac</em> Debit for Online Payments financial institution.'));
      this.updateChatbotState(OnlineBus1);
      const moreQuestionsMessage = this.createChatBotMessage(parse('Is there anything else I can help with?'),
        {
          widget: 'MoreQuestions',
        }
      );
      this.updateChatbotState(moreQuestionsMessage);
    };
    OnlineBus2 = () => {
      const OnlineBus2 = this.createChatBotMessage(parse('<em>Interac</em> Debit for online payments is a secure payment system for Canadian e-Commerce. When a customer goes to checkout, a new browser window will open directing the customer to their online banking account. So you as the merchant never handle any confidential information.<br />Please visit our <em>Interac</em> Debit for online payments page for more information on <a href="https://www.interac.ca/en/business/our-solutions/interac-online/" target="_blank">how it works</a>.'));
      this.updateChatbotState(OnlineBus2);
      const moreQuestionsMessage = this.createChatBotMessage(parse('Is there anything else I can help with?'),
        {
          widget: 'MoreQuestions',
        }
      );
      this.updateChatbotState(moreQuestionsMessage);
    };
    OnlineBus3 = () => {
      const OnlineBus3 = this.createChatBotMessage(parse('Customers must be registered for online banking to use <em>Interac</em>  Debit for online payments.<br />If a customer tries to check out with <em>Interac</em>  Debit for online payments, but isn’t enrolled in online banking, the customer’s bank or credit union may provide an option to register right away.<br />The customer will also be provided with a link back to your website, so in the event he/she decides not to register for online banking, you can allow checkout via another payment method.'));
      this.updateChatbotState(OnlineBus3);
      const moreQuestionsMessage = this.createChatBotMessage(parse('Is there anything else I can help with?'),
        {
          widget: 'MoreQuestions',
        }
      );
      this.updateChatbotState(moreQuestionsMessage);
    };
    OnlineBus4 = () => {
      const OnlineBus4 = this.createChatBotMessage(parse('One of the main benefits of <em>Interac</em> Debit for online payments is the separation of shopping and payment. The customer is taken to his or her online banking website to pay. This means the customer does not have to enter confidential account information on your website. Studies show customers have concerns over sharing financial or account details with online merchants.<br />Once an online payment is made via <em>Interac</em> Debit, the browser will automatically redirect to your website. If the customer is unable to or decides not to authorize the payment through online banking, he/she is still brought back to your website, allowing you to continue checkout through a different payment method.'));
      this.updateChatbotState(OnlineBus4);
      const moreQuestionsMessage = this.createChatBotMessage(parse('Is there anything else I can help with?'),
        {
          widget: 'MoreQuestions',
        }
      );
      this.updateChatbotState(moreQuestionsMessage);
    };
    OnlineBus5 = () => {
      const OnlineBus5 = this.createChatBotMessage(parse('Some Acquirers and payment service providers support <em>Interac</em> Debit for online payments refunds. This allows you to credit the refund back into the bank account the customer used for the purchase.<br />The refund policy is at your discretion. You always have the option to provide refunds through other mechanisms (e.g. providing a store credit or sending a cheque).'));
      this.updateChatbotState(OnlineBus5);
      const moreQuestionsMessage = this.createChatBotMessage(parse('Is there anything else I can help with?'),
        {
          widget: 'MoreQuestions',
        }
      );
      this.updateChatbotState(moreQuestionsMessage);
    };
    OnlineBus6 = () => {
      const OnlineBus6 = this.createChatBotMessage(parse('In the credit card world, an authorized transaction can be reversed. For example, if a fraudulent transaction has been charged to a customer’s account and the customer disputes the transaction. To avoid chargebacks, merchants often perform checks before accepting a transaction and refuse to accept it, if it appears suspicious. However, the transaction may actually be legitimate. This practice has the negative effect of preventing a valid customer from completing a purchase.<br />Interac does not use or require chargebacks. The customer’s bank or credit union authorizes and guarantees each payment.'));
      this.updateChatbotState(OnlineBus6);
      const moreQuestionsMessage = this.createChatBotMessage(parse('Is there anything else I can help with?'),
        {
          widget: 'MoreQuestions',
        }
      );
      this.updateChatbotState(moreQuestionsMessage);
    };
    handleABMBus = () => {
      const message = this.createChatBotMessage(
        'What can we help you with?',
        {
          widget: 'AbmOptionsBus',
        }
      );
  
      this.updateChatbotState(message);
    };
    AbmBus1 = () => {
      const AbmBus1 = this.createChatBotMessage(parse('ABM withdrawals are a convenient way to withdraw cash from your account at any Automated Banking Machine (ABM) displaying the <em>Interac</em> logo, anywhere in Canada.<br />Interac has made accessing your account for cash withdrawals convenient with more than 70,0000 ABMs available across Canada, many of which are available 24 hours a day.'));
      this.updateChatbotState(AbmBus1);
      const moreQuestionsMessage = this.createChatBotMessage(parse('Is there anything else I can help with?'),
        {
          widget: 'MoreQuestions',
        }
      );
      this.updateChatbotState(moreQuestionsMessage);
    };
    AbmBus2 = () => {
      const AbmBus2 = this.createChatBotMessage(parse('Housing an ABM can increase foot traffic to your location, increasing awareness of your business and goods or services.'));
      this.updateChatbotState(AbmBus2);
      const moreQuestionsMessage = this.createChatBotMessage(parse('Is there anything else I can help with?'),
        {
          widget: 'MoreQuestions',
        }
      );
      this.updateChatbotState(moreQuestionsMessage);
    };
    AbmBus3 = () => {
      const AbmBus3 = this.createChatBotMessage(parse('An Acquirer can help you with that information. Please visit our ABM Withdrawals page to find a <a href="https://www.interac.ca/en/business/how-it-works/find-an-acquirer/#fi-list-acquirers-interac-cash-service-abm" target="_blank">list of all participating Acquirers.</a>'));
      this.updateChatbotState(AbmBus3);
      const moreQuestionsMessage = this.createChatBotMessage(parse('Is there anything else I can help with?'),
        {
          widget: 'MoreQuestions',
        }
      );
      this.updateChatbotState(moreQuestionsMessage);
    };
    AbmBus4 = () => {
      const AbmBus4 = this.createChatBotMessage(parse('The customer bank issuing the <em>Interac</em> debit card will handle any instances of fraud. However, you should always ensure you follow any security recommendations and measures your Acquirer provides on installation.'));
      this.updateChatbotState(AbmBus4);
      const moreQuestionsMessage = this.createChatBotMessage(parse('Is there anything else I can help with?'),
        {
          widget: 'MoreQuestions',
        }
      );
      this.updateChatbotState(moreQuestionsMessage);
    };
    AbmBus5 = () => {
      const AbmBus5 = this.createChatBotMessage(parse('For all questions and details related to ABM Withdrawals, please speak with an Acquirer. You can find a <a href="https://www.interac.ca/en/business/how-it-works/find-an-acquirer/#fi-list-acquirers-interac-cash-service-abm" target="_blank">list of all participating Acquirers</a> on our ABM Withdrawals page.'));
      this.updateChatbotState(AbmBus5);
      const moreQuestionsMessage = this.createChatBotMessage(parse('Is there anything else I can help with?'),
        {
          widget: 'MoreQuestions',
        }
      );
      this.updateChatbotState(moreQuestionsMessage);
    };
    AbmBus6 = () => {
      const AbmBus6 = this.createChatBotMessage(parse('For any troubleshooting support, please contact your ABM Acquirer.'));
      this.updateChatbotState(AbmBus6);
      const moreQuestionsMessage = this.createChatBotMessage(parse('Is there anything else I can help with?'),
        {
          widget: 'MoreQuestions',
        }
      );
      this.updateChatbotState(moreQuestionsMessage);
    };

    
    

    handleSafetySecurity = () => {
      const message = this.createChatBotMessage(
        'What kind of question do you have?',
        {
          widget: 'SafetySecurity',
        }
      );
  
      this.updateChatbotState(message);
    };

    handleBusinessSupport = () => {
      const message = this.createChatBotMessage(
        'How can we offer help?',
        {
          widget: 'BusinessSupport',
        }
      );
  
      this.updateChatbotState(message);
    };

    handleCareers = () => {
      const message = this.createChatBotMessage(
        'What kind of question do you have?',
        {
          widget: 'Careers',
        }
      );
  
      this.updateChatbotState(message);
    };

    handleFeedback = () => {
      const message = this.createChatBotMessage(
        'I\'m always looking for feedback. Let me know how you thought I did today.',
        {
          widget: 'Feedback',
        }
      );
  
      this.updateChatbotState(message);
    };
    handleLikedIt = () => {
      const message = this.createChatBotMessage(
        'Thanks for the positive feedback.',
      );
  
      this.updateChatbotState(message);
    };
    handleHatedIt = () => {
      const message = this.createChatBotMessage(
        'Sorry I wasn\'t helpful. I\'ll pass your feedback along so that I can improve.',
      );
  
      this.updateChatbotState(message);
    };
    handleSoSo = () => {
      const message = this.createChatBotMessage(
        'Sorry I wasn\'t helpful. I\'ll pass your feedback along so that I can improve.',
      );
  
      this.updateChatbotState(message);
    };
  
    updateChatbotState(message) {
      // NOTICE: This function is set in the constructor, and is passed in from the top level Chatbot component. The setState function here actually manipulates the top level state of the Chatbot, so it's important that we make sure that we preserve the previous state.
  
      this.setState((prevState) => ({
        ...prevState,
        messages: [...prevState.messages, message],
      }));
    }
  }
  
  export default ActionProvider;